import * as React from 'react';
import { getBasePath } from '../../../utils/browser';

// FIXME: ToolIconButtonのコピペ実装

interface HoldIconButtonProps {
  readonly onHold: () => void;
  readonly iconName: string;
  readonly className?: string;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly margin?: boolean;
}

interface HoldIconButtonState {
  readonly isHold: boolean;
}

class HoldIconButton extends React.PureComponent<HoldIconButtonProps, HoldIconButtonState> {
  private readonly baseDir: string;
  private rAFID: number | null = null;

  public constructor(props: HoldIconButtonProps) {
    super(props);
    this.state = { isHold: false };
    this.baseDir = getBasePath();
  }

  private handleHoldStart = () => {
    this.setState({ isHold: true });
  }

  private handleHoldEnd = () => {
    this.setState({ isHold: false });
  }

  private initHold = () => {
    if (this.rAFID !== null) {
      window.cancelAnimationFrame(this.rAFID);
    }
  }

  private holdHandler = (): void => {
    if (!this.props.disabled && this.props.onHold !== undefined) {
      this.props.onHold();
    }
    this.rAFID = window.requestAnimationFrame(this.holdHandler);
  }

  public componentDidUpdate() {
    this.initHold();
    if (this.state.isHold) {
      this.holdHandler();
    }
  }

  public componentWillUnmount() {
    this.initHold();
  }

  public render() {
    const iconButtonStyle: React.CSSProperties = {
      width: '48px',
      height: '48px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'inherit',
      textDecoration: 'none',
      background: 'rgba(0, 0, 0, 0.1)',
      boxSizing: 'border-box',
    };

    const { props } = this;

    if (props.margin !== false) {
      iconButtonStyle.margin = '8px';
    }
    if (props.active) {
      iconButtonStyle.border = '2px solid white';
    }
    if (props.disabled) {
      iconButtonStyle.filter = 'brightness(0.5)';
    }

    const imgSrc = `${this.baseDir}/images/tool-icons/${props.iconName}.png`;

    return (
      <a
        style={{ ...iconButtonStyle, ...props.style }}
        href={props.href}
        onMouseDown={this.handleHoldStart}
        onTouchStart={this.handleHoldStart}
        onMouseUp={this.handleHoldEnd}
        onMouseMove={this.handleHoldEnd} // やや強引だが移動でもホールドを終えるようにしている
        onTouchMove={this.handleHoldEnd}
        onTouchEnd={this.handleHoldEnd}
        onTouchCancel={this.handleHoldEnd}
        title={props.title}
        aria-label={props.ariaLabel}>
        <img src={imgSrc} style={{ maxWidth: '48px', maxHeight: '48px' }} />
      </a>
    );
  }
}

export default HoldIconButton;
